// © 2026 Orpyx Medical Technologies Inc.

import {PropertyNamePipe} from "orpyx-web-common";
import {Field, useFormikContext} from "formik";
import {Select} from "formik-material-ui";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as React from "react";
import {memo} from "react";
import {CarePractitionerActionSelectorProps} from "./care-practitioner-action-selector.interface";
import {useCarePractitionerActionSelectorStyle} from "./care-practitioner-action-selector.style";
import {ImageUrlPipe} from "../../../../../../shared/pipes/image-url-pipe";
import {PatientSubmitCareNoteFormValues} from "../patient-submit-care-note-form/patient-submit-care-note-form.interface";

export const CarePractitionerActionSelector = memo((props: CarePractitionerActionSelectorProps) => {
    const classes = useCarePractitionerActionSelectorStyle();

    const {errors, touched} = useFormikContext<PatientSubmitCareNoteFormValues>();

    const fieldName = PropertyNamePipe(props.values, 'actionId');
    const inputProps = {
        id: fieldName,
        name: fieldName
    };

    //  formik-material-ui's Select drops error / helperText, unlike its TextField, so the
    //  surrounding FormControl carries the error state and the message instead.
    const showError = Boolean(touched.actionId && errors.actionId);

    return (
        <FormControl error={showError} fullWidth={true}>
            <Field
                component={Select}
                className={props.classes.input}
                name={fieldName}
                value={props.selectedAction}
                inputProps={inputProps}
            >
                {props.actions.map(action => (<MenuItem key={action.id} value={action.id}>
                    <img
                        alt={action?.name!}
                        src={ImageUrlPipe(action?.url)}
                        className={classes.icon}
                    />

                    {action.name}
                </MenuItem>))}
            </Field>

            {showError && <FormHelperText>
                {errors.actionId}
            </FormHelperText>}
        </FormControl>
    );
});
